import { Card } from "@kontaktfix/ui";
import { DeviceMobileIcon, InfoIcon } from "@phosphor-icons/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Page, PageHeader } from "@/components/page";
import { markPhoneGuideSeen } from "./home";

function Steps({ title, steps }: { title: string; steps: readonly string[] }) {
  return (
    <Card className="p-5">
      <div className="mb-4 flex items-center gap-2 text-[14px] font-semibold">
        <DeviceMobileIcon className="size-4 text-fg-muted" />
        {title}
      </div>
      <ol className="flex flex-col gap-3">
        {steps.map((step, i) => (
          <li key={step} className="flex gap-3 text-[13px]">
            <span className="flex size-5 shrink-0 items-center justify-center rounded-full bg-accent-soft text-[11px] font-semibold text-accent">
              {i + 1}
            </span>
            {step}
          </li>
        ))}
      </ol>
    </Card>
  );
}

export function PhoneGuidePage() {
  const { t } = useTranslation();
  useEffect(markPhoneGuideSeen, []);
  const ios = t("phone.ios", { returnObjects: true }) as string[];
  const android = t("phone.android", { returnObjects: true }) as string[];
  const notes = t("phone.notes", { returnObjects: true }) as string[];

  return (
    <Page>
      <PageHeader title={t("phone.title")} description={t("phone.description")} />
      <div className="grid gap-4 md:grid-cols-2">
        <Steps title={t("phone.iosTitle")} steps={ios} />
        <Steps title={t("phone.androidTitle")} steps={android} />
      </div>
      <Card className="mt-4 p-5">
        <div className="text-[14px] font-semibold">{t("phone.itTitle")}</div>
        <p className="mt-1 text-[13px] text-fg-muted">{t("phone.itText")}</p>
      </Card>
      <Card className="mt-4 p-5">
        <div className="mb-3 flex items-center gap-2 text-[14px] font-semibold">
          <InfoIcon className="size-4 text-fg-muted" />
          {t("phone.noteTitle")}
        </div>
        <ul className="flex list-disc flex-col gap-2 pl-5 text-[13px] text-fg-muted">
          {notes.map((n) => (
            <li key={n}>{n}</li>
          ))}
        </ul>
      </Card>
    </Page>
  );
}
